<template>
     <v-app class="white">
        <!--배경 그라이데션 -->
        <div class="background-postion">
            <img 
            src="@/assets/main_wallet_bg01.png"
            class="img-background-postion">
        </div>
        <!-- 상단타이틀 -->
        <div class="top-bg">
            <!-- 타이틀 -->
            <div class="top-title-logo">
                <img 
                src="@/assets/top_title_img.png"
                class="img-title-logo"> 
            </div> 
            <!-- 옵션메뉴 버튼 -->
            <div class="top-option-position"
            @click.passive="onClickOption()"
            v-ripple="{ center: true, class: `teal--text`  }">
                <img 
                src="@/assets/option_icon.png"
                class="img-option"> 
            </div> 
            <div 
            @click.passive="onClickLang()"
            v-ripple="{ center: true, class: `teal--text`  }"
            class="select-lang">
                <img 
                :src="mImgLang"
                class="img-language"> 
            </div> 
        </div> 
        <!-- 공지사항 배경 -->
        <div class="notice-bg-postion">
            <img 
            src="@/assets/notice_bg.png"
            class="img-notice-bg"> 
            <div>
                <img
                src="@/assets/news_icon.png"
                class="img-news-icon"> 
                <div class="notice-position">{{this.mNoticeContent}}</div>
            </div>
        </div>
 
        <!-- 지갑 리스트  -->
        <div class="list-wallet-position">
            <v-sheet
            class="list-wallet-bg-02"
            max-width="100vw"
            >
            <v-slide-group multiple show-arrows:false >
                <v-slide-item
                v-for="n in this.mListData"
                :key="n.coin_type">
                    <div class="wallet-list-item">
                        <div class="wallet-list-item-00">
                            <img
                                src="@/assets/wallet_bg.png"
                                class="wallet-item-bg">
                            <!-- 상단 이미지 -->
                            <img
                                :src="n.image_url"
                                class="img-wallet-top-bg">
                            <!-- is_made 1 생성된 상태 -->
                            <div v-show="n.is_made == 1 && n.status == '2'"> 
                                <!-- 코인이미지 -->
                                <img
                                    :src="n.icon_url"
                                    class="wallet-item-icon">
                                <div class="wallet-name-position" v-show="$langUtil.getLang() == 'ko'">{{n.name}}({{ n.symbol.toUpperCase() }})</div>
                                <div class="wallet-name-position" v-show="$langUtil.getLang() == 'en'">
                                    {{n.name_en}}({{ n.symbol.toUpperCase() }})
                                </div>
                                <img
                                    src="@/assets/wallet_item_price_bg.png"
                                    class="img-item-price-bg">
                                <div class="txt-item-price-value"> {{ $satoshiUtil.satoshiToMCH(n.balance) }} {{ n.symbol.toUpperCase() }} </div>
                                
                               <!-- 미콘캐시-->
                                <div v-show="n.coin_type == '3'"> 
                                     <img
                                    src="@/assets/wallet_item_btn_bg.png"
                                    class="img-wallet-btn-bg">
                                    <!-- 받기 버튼 -->
                                    <img
                                        src="@/assets/receive_icon.png"
                                        @click.passive="onClickListReceive(n)"
                                        v-ripple="{ center: true, class: `teal--text`  }"
                                        class="img-wallet-btn-receive">
                                    <div class="txt-receive-wallet">{{ $t('receive') }}</div>
                                    <!-- 보내기 버튼 -->
                                    <img
                                        src="@/assets/send_icon.png"
                                        @click.passive="onClickListSend(n)"
                                        v-ripple="{ center: true, class: `teal--text`  }"
                                        class="img-wallet-btn-send">
                                    <div class="txt-send-wallet">{{ $t('send') }}</div> 
                                </div>
                               <!-- 미콘캐시 외에 코인-->
                                <div v-show="n.coin_type != '3'"> 
                                     <img
                                    src="@/assets/ether_list_bg.png"
                                    class="img-wallet-btn-bg">
                                    <!-- 받기 버튼 -->
                                    <img
                                        src="@/assets/receive_icon.png"
                                        @click.passive="onClickListReceive(n)"
                                        v-ripple="{ center: true, class: `teal--text`  }"
                                        class="img-wallet-btn-receive-02">
                                    <div class="txt-receive-wallet-02">{{ $t('receive') }}</div>
                                    <!-- 보내기 버튼 -->
                                    <img
                                        src="@/assets/send_icon.png"
                                        @click.passive="onClickListSend(n)"
                                        v-ripple="{ center: true, class: `teal--text`  }"
                                        class="img-wallet-btn-send-02">
                                    <div class="txt-send-wallet-02">{{ $t('send') }}</div> 
                                    <!-- 전환 버튼 -->
                                    <img
                                        src="@/assets/btn_convert_wallet.png"
                                        @click.passive="onClickListConvert(n)"
                                        v-ripple="{ center: true, class: `teal--text`  }"
                                        class="img-wallet-btn-convert-02">
                                    <div class="txt-convert-wallet-02">{{ $t('convert_menu') }}</div> 
                                </div>
                                <!-- 바로가기 버튼 -->
                                <img
                                    @click.passive="onClickDetail(n)"
                                    v-ripple="{ center: true, class: `teal--text`  }"
                                    src="@/assets/link_wallet.png"
                                    class="img-wallet-link-detail">
                            </div>
                            <!-- is_made 0 생성안된 상태 -->
                            <div v-show="n.is_made == 0 && n.status == '2'"> 
                                <!-- 코인이미지 -->
                                <img
                                    :src="n.icon_url"
                                    class="wallet-item-icon">
                                <div class="wallet-name-position" v-show="$langUtil.getLang() == 'ko'">{{ n.name }}({{ n.symbol.toUpperCase() }})</div>
                                <div class="wallet-name-position" v-show="$langUtil.getLang() == 'en'">
                                    {{ n.name_en }}({{ n.symbol.toUpperCase() }})
                                </div>
                                <img
                                src="@/assets/wallet_item_price_bg.png"
                                class="img-item-price-bg">
                                <!-- 지갑생성 -->
                                <div class="wallet-create-new">{{ $t('create_wallet') }}</div>
                                <!-- 지갑생성 버튼 -->
                                <img
                                    @click.passive="onClickCreate(n)"
                                    v-ripple="{ center: true, class: `teal--text`  }"
                                    src="@/assets/img_wallet_create.png"
                                    class="img-wallet-link-detail">
                            </div>     
                            <!-- 준비중인 상태 -->
                            <div v-show="n.status == '1'"> 
                                <!-- 코인이미지 -->
                                <img
                                    :src="n.icon_url"
                                    class="wallet-item-icon">
                                <div class="wallet-name-position" v-show="$langUtil.getLang() == 'ko'">{{ n.name }}({{ n.symbol.toUpperCase() }})</div>
                                <div class="wallet-name-position" v-show="$langUtil.getLang() == 'en'">
                                    {{ n.name_en }}({{ n.symbol.toUpperCase() }})
                                </div>
                                <img
                                src="@/assets/wallet_item_price_bg.png"
                                class="img-item-price-bg">
                                <!-- 지갑생성 -->
                                <div class="wallet-create-new">{{ $t('getready') }}</div>
                                <!-- 지갑생성 버튼 -->
                                <img
                                    v-ripple="{ center: true, class: `teal--text`  }"
                                    src="@/assets/img_wallet_create.png"
                                    class="img-wallet-link-detail">
                            </div>                                                   
                        </div>
                    </div>
                </v-slide-item>
            </v-slide-group>
            </v-sheet>
        </div>
        <div class="loading-bar-postion" v-show="mShowLoading">
        <v-progress-circular
          indeterminate
          color="red"
        ></v-progress-circular>
      </div>
    <!-- 옵션 -->
    <v-dialog v-model="drawer" fullscreen hide-overlay transition="slide-x-transition">
        <div class="option-top-bg">     
            <div 
            @click.passive="onClickLogout()"
            v-ripple="{ center: true, class: `teal--text`  }"
            class="option-top-logout"></div>
            <div class="option-logout">
                <img
                src="@/assets/btn_logout.png"
                class="img-logout"> 
            </div>
            <div class="option-txt-logout">{{ $t('logout') }}</div>
            <div 
            @click.passive="onClickOptionClose()"
            v-ripple="{ center: true, class: `teal--text`  }"
            class="option-close-position">
                <img
                src="@/assets/option_close.png"
                class="img-option-close">
            </div>
            <!-- 구글아이콘 -->
            <div class="option-google-icon-position">
                <img
                src="@/assets/google_icon_mark.png"
                class="img-google-icon"/>  
            </div>
            <!-- 구글이메일 -->
            <div class="option-email-postion">{{this.mEmail}}</div>
            <!-- 라인 -->
            <div class="option-top-line1"></div>
            <!-- support 라인 -->
            <div class="option-surpport-bg">
                <img
                src="@/assets/option_support.png"
                class="img-support-bg"/> 
            </div>
            <!-- 공지사항 -->
            <div 
            @click.passive="onClickNotice()"
            v-ripple="{ center: true, class: `teal--text`  }"
            class="option-notice-postion">
                <img
                src="@/assets/option_suport_list.png"
                class="option-img-notice-bg"/>
                <div class="option-txt-center">{{ $t('notice') }}</div>
            </div>
            <!-- 뉴스 -->
            <div 
                @click.passive="onClickNews()"
                v-ripple="{ center: true, class: `teal--text`  }"
                class="option-notice-news">
                <img
                src="@/assets/option_suport_list.png"
                class="option-img-notice-bg"/>
                <div class="option-txt-center">{{ $t('news') }}</div>
            </div> 
            <!-- 푸시알림 -->
            <div 
                @click.passive="onClickPushList()"
                v-ripple="{ center: true, class: `teal--text`  }"
                class="option-notice-push">
                <img
                src="@/assets/option_suport_list.png"
                class="option-img-notice-bg"/>
                <div class="option-txt-center">{{ $t('settting_push') }}</div>
            </div>
           <!-- FAQ -->
            <div 
                @click.passive="onClickFAQ()"
                v-ripple="{ center: true, class: `teal--text`  }"
                class="option-notice-faq">
                <img
                src="@/assets/option_suport_list.png"
                class="option-img-notice-bg"/>
                <div class="option-txt-center">FAQ</div>
            </div>   
           <!-- 비밀번호찾기 -->
            <div 
                @click.passive="onClickPwd()"
                v-ripple="{ center: true, class: `teal--text`  }"            
                class="option-notice-pwd">
                <img
                src="@/assets/option_suport_list.png"
                class="option-img-notice-bg"/>
                <div class="option-txt-center">{{ $t('find_pass') }}</div>
            </div> 
            <!-- setting 라인 -->
            <div class="option-setting-bg">
                <img
                src="@/assets/option_setting_bg.png"
                class="img-setting-bg"/> 
            </div>   
           <!-- 비밀번호 설정 -->
            <div 
                @click.passive="onClickPassword()"
                v-ripple="{ center: true, class: `teal--text`  }"            
                class="option-chage-pwd">
                <img
                src="@/assets/option_setting_bg_2.png"
                class="option-img-notice-bg2"/>
                <div class="option-txt-center2">{{ $t('setting_pass') }}</div>
                <div class="option-txt-center3">{{ $t('setting_pass_desc') }}</div>
            </div>
           <!-- 잠금화면 설정 
            <div 
                @click.passive="onClickLockScreen()"
                v-ripple="{ center: true, class: `teal--text`  }"            
                class="option-lock-screen">
                <img
                src="@/assets/option_setting_bg_2.png"
                class="option-img-notice-bg2"/>
                <div class="option-txt-center2">잠금화면 설정</div>
                <div class="option-txt-center3">어플을 시작할 때 화면잠금을 설정</div>
            </div> 
            -->
           <!-- 푸쉬설정 
            <div 
                @click.passive="onClickPush()"
                v-ripple="{ center: true, class: `teal--text`  }"            
                class="option-setting-push">
                <img
                src="@/assets/option_setting_bg_2.png"
                class="option-img-notice-bg2"/>
                <div class="option-txt-center2">푸쉬설정</div>
                <div class="option-txt-center3">거래가 완료될 때 푸쉬로 알림 설정</div>
            </div>    
            -->
           <!-- 통화설정 
            <div 
                @click.passive="onClickCurrency()"
                v-ripple="{ center: true, class: `teal--text`  }"            
                class="option-setting-phone">
                <img
                src="@/assets/option_setting_bg_2.png"
                class="option-img-notice-bg2"/>
                <div class="option-txt-center2">통화설정</div>
                <div class="option-txt-center3">통화 단위를 설정</div>
            </div>     
             -->                                                                                             
        </div>
    </v-dialog>
    <!-- 언어선택 -->
    <v-dialog v-model="mLangDialog">
        <div class="lang_dialog_bg"> 
            <div class="lang_dialog_title">{{ $t('sel_lang') }}</div>
            <div 
            @click.passive="onClickLangEn()"
            v-ripple="{ center: true, class: `teal--text`  }"           
            class="lang_dialog_ko">
                <img
                src="@/assets/usa_flag.png"
                class="lang-popup-flag"/>
                <div class="lang-popup-text">{{ $t('lang_en') }}</div>
            </div>
            <div 
            @click.passive="onClickLangKo()"
            v-ripple="{ center: true, class: `teal--text`  }"           
            class="lang_dialog_en">
                <img
                src="@/assets/korean_flag.png"
                class="lang-popup-flag"/>
                <div class="lang-popup-text">{{ $t('lang_ko') }}</div>
            </div>
        </div>
    </v-dialog>
    </v-app>
</template>
<script>
import axios from 'axios';
import { constants } from 'crypto';

export default {
    created() {
        window['isHome'] = this.isHome;
        window['regPushID'] = this.regPushID;
        let payload = this.$route.query.payload;
        let decrypto = this.$cryptoUtil.decrptoMessage(payload);
        let json = JSON.parse( JSON.parse( decrypto ) ); // 두번사용해야 정상으로 나옴
        this.mMno = json.mno;
        this.mEmail = json.email;
        this.mNoticeContent = json.notice;
        this.mLoginKey = json.login_key;
        this.getWalletList();
        console.log("loing_key :" + this.mLoginKey);
        let lang = this.$langUtil.getLang();
        console.log("" + lang)
        this.showLangFlag(lang);
        this.drawer = this.$appConst.showDrawer;
    },
    destroyed() {
        window['isHome'] = undefined;
        this.mListData = [];
        this.$appConst.showDrawer = this.drawer;
    },
    data: () => ({
        mMno : "",
        mPasswd : "",
        mListData : [],
        mShowLoading : false,
        mNoticeContent : "",
        drawer: false,
        mEmail:"",
        mLoginKey : "",
        mImgLang : "",
        mLangDialog : false,
    }),
    methods : {
        isHome() {
            this.isHomeApp();
        },
        isHomeApp() {
            try {
                window.MeconWalletJS.isHomeApp(true);
            } catch(error) {
            }
            try {
                let payload = {};
                payload.key = "isHomeApp";
                payload.msg = true;
                window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(payload));
            } catch(error) {
            }
        },
        getWalletList : function() { // 지갑리스트 가져옴
            if(this.mMno == undefined) {
                return;
            }
            this.mListData = [];

            let payload = {};
            payload.cmd = "coin-wallet-list";
            payload.mno = this.mMno;

            this.mShowLoading = true;
            axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
            .then(response => {
                console.log("" + JSON.stringify(response) )
                let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K")); 
                this.mShowLoading = false;
                var list = serverResponse.list;
                console.log("" + JSON.stringify(list))
                for(var i = 0 ;i < list.length ; i++) {


                    if(this.mEmail == 'sk8er12379@gmail.com' || this.mEmail == 'javamoon71@gmail.com') {
                        serverResponse.list[i].status = 2; // test
                    }
                    

                    this.mListData.push(serverResponse.list[i]);
                }
                this.reqPushId(); // 푸시아이디 폰에 요청
            })
            .catch( ()=>{} );
        },
        onClickListSend(selItem) {
            let payload = {};
            payload.mno = this.mMno;
            payload.coin_type = selItem.coin_type;
            payload.symbol = selItem.symbol;
            payload.icon_url =selItem.icon_url;
            payload.address = selItem.address;
            payload.send_fee = selItem.send_fee;
            payload.login_key = this.mLoginKey;
            let payloadJson = JSON.stringify(payload);
            let crypto = this.$cryptoUtil.crotoMessage(payloadJson);
            this.$router.push( { path : 'send_main', query: { payload : crypto } } );
        },
        onClickListReceive(selItem) {
            let payload = {};
            payload.mno = this.mMno;
            payload.coin_type = selItem.coin_type;
            payload.symbol = selItem.symbol;
            payload.icon_url = selItem.icon_url;
            payload.address = selItem.address;
            let payloadJson = JSON.stringify(payload);
            let crypto = this.$cryptoUtil.crotoMessage(payloadJson);
            this.$router.push( { path : 'receive_main', query: { payload : crypto } } );
        },
        onClickListConvert(selItem) {
            let payload = {};
            payload.mno = this.mMno;
            payload.coin_type = selItem.coin_type;
            payload.symbol = selItem.symbol;
            payload.icon_url = selItem.icon_url;
            payload.address = selItem.address;
            payload.coin_name = selItem.name;
            payload.coin_name_en = selItem.name_en;
            payload.login_key = this.mLoginKey;
            let payloadJson = JSON.stringify(payload);
            let crypto = this.$cryptoUtil.crotoMessage(payloadJson);
            this.$router.push( { path : 'convert_main', query: { payload : crypto} } );
        },
        onClickLogout : function() {
            console.log("onClickLogout")
            // 모바일폰 로그아웃
            if(this.$appUtil.getLauncher() == 'android' || this.$appUtil.getLauncher() == 'ios') {
                try {
                    window.WalletExJs.logout();
                } catch(error) {
                }
                try {
                    let payload = {};
                    payload.key = "logout";
                    window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(payload));
                } catch(error) {
                }
                return;
            } 
            // 웹페이지 로그아웃
            this.$gAuth.signOut()
            .then(() => {
                this.$router.replace( { path : 'login' } );
            })
            .catch(error  => {
            })   
        
        },
        onClickDetail : function(selItem) {
            console.log("selItem :: " + JSON.stringify(selItem))
            let payload = {};
            payload.mno = this.mMno;
            payload.coin_type = selItem.coin_type;
            payload.symbol = selItem.symbol;
            payload.icon_url = selItem.icon_url;
            payload.address = selItem.address;
            payload.coin_name = selItem.name;
            payload.coin_name_en = selItem.name_en;
            payload.send_fee = selItem.send_fee;
            payload.login_key = this.mLoginKey;
            let payloadJson = JSON.stringify(payload);
            let crypto = this.$cryptoUtil.crotoMessage(payloadJson);

            this.$router.push( { path : 'wallet_main', query: { payload : crypto } });
        },
        onClickCreate : function(selItem) { // 지갑생성하기
            let payload = {};
            payload.cmd = "new-wallet";
            payload.mno = this.mMno;
            payload.coin_type = selItem.coin_type;
            payload.name = selItem.name;
            payload.symbol = selItem.symbol;
            
            console.log("" + this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))

            this.mShowLoading = true;
            axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
            .then(response => {
                console.log(response);
                let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K"));
                this.mShowLoading = false;
                if(serverResponse.result == "1") { // 성공
                    alert(this.$t('message_create'));
                    this.getWalletList();
                } else if(serverResponse.result == "2") { // 기존사용자존재
                    alert(this.$t('exist_user'));
                } else if(serverResponse.result == "0") { // 오류
                    alert(serverResponse.message);
                }
            })
            .catch( ()=>{} );
        },
        onClickOption : function() {
            this.drawer = true;
        },
        onClickOptionClose : function() {
            this.drawer = false;
        },
        onSuccess : function() {
            console.log("onSuccess")
        },
        onFailure : function() {
            console.log("onFailure")
        },
        onClickNotice : function() {
            console.log("onClickNotice")
            this.$router.push( { path : 'notice_list' } );
        },
        onClickNews : function() {
            console.log("onClickNews")
            this.$router.push( { path : 'news_list' } );
        },
        onClickPushList : function() {
            console.log("onClickPush")
            this.$router.push( { path : 'push_list' } );
        },
        onClickFAQ : function() {
            console.log("onClickFAQ")
            this.$router.push( { path : 'faq_list' } );
        },
        onClickPwd : function() {
            console.log("onClickPwd")
            this.$router.push( { path : 'find_passwd' } );
        },
        onClickPassword : function() {
            console.log("onClickChagePwd")
            let payload = {};
            payload.mno = this.mMno;
            payload.mode = "0";
            
            let payloadJson = JSON.stringify(payload);
            let crypto = this.$cryptoUtil.crotoMessage(payloadJson);
            this.$router.push( { path : 'charge_passwd', query: { payload : crypto } } );
        },
        onClickCurrency : function() {
            this.$router.push( { path : 'setting_currency' } );
        },
        onClickLockScreen : function() {
            this.$router.push( { path : 'setting_locak_screen' } );
        },
        onClickSettingPush : function() {
            this.$router.push( { path : 'setting_push' } );
        },
        onClickLang : function() {
            this.mLangDialog = true;
        },
        onClickLangKo() {
            this.mLangDialog = false;
            this.chargeLang('ko');
        }, 
        onClickLangEn() {
            this.mLangDialog = false;
            this.chargeLang('en');
        },
        chargeLang(lang) {
            this.$langUtil.setLang(lang, this.$i18n);
            if(lang == 'ko') {
                this.mImgLang = require("@/assets/korean_flag.png");
            } else {
                this.mImgLang = require("@/assets/usa_flag.png");
            }
            this.showLangFlag(lang);
        },
        showLangFlag(lang) {
            if(lang == 'ko') {
                this.mImgLang = require("@/assets/korean_flag.png");
            } else {
                this.mImgLang = require("@/assets/usa_flag.png");
            }
        },
        regPushID(pushid) { // 푸시토큰 서버에 보냄
            let payload = {};
            payload.cmd = "update-token-id";
            payload.mno = this.mMno;
            payload.token_id = pushid;
            this.mShowLoading = true;
            axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
            .then(response => {
                let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K")); 
                console.log(response);
                this.mShowLoading = false;
            })
            .catch( ()=>{} );
        },
        reqPushId() { // 폰에 푸시토큰 요청
            // 모바일폰 로그아웃
            if(this.$appUtil.getLauncher() == 'android' || this.$appUtil.getLauncher() == 'ios') {
                try {
                    window.WalletExJs.reqPushId();
                } catch(error) {
                }
                try {
                    let payload = {};
                    payload.key = "reqPushId";
                    window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(payload));
                } catch(error) {
                }
                return;
            } 
        }
    },
}
</script>
<style scoped>
* {
    margin: 0;
    font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; 
    font-weight: 300;
    padding: 0;
}
html, body {
    height: 100vh;
    width: 100vw;
}
.top-bg {
    position: absolute;
    top: 0vh;
    left: 0vw;
    width: 100vw;
    height: 13.24vw;
    background-color: white;
}
.img-top-bg {
    height: 13.24vw;
    width: 100vw;
}
.top-option-position {
    position: absolute;
    top: 0vh;
    left: 0vw;      
    height: 13.24vw;
    width: 13.24vw;
}
.img-option {
    position: absolute;
    top: 4.07vw;
    right: 5.64vw;
    height: 3.703704vw;
    width: 4.07vw;
}
.top-title-logo {
    position: absolute;
    top: 50%; 
    left: 50%;
    width: auto;
    height: 5.925926vw;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
    pointer-events: none;
    background-color: white;
}
.img-title-logo {
    height: 5.925926vw;
    width: auto;
}
.notice-bg-postion {
    position: absolute;
    top: 17.037vw; 
    left: 0vw;
}
.img-notice-bg {
    width: 100vw;
    height: 6.481481vw;
}
.img-news-icon {
    position: absolute;
    top: 12%; 
    left: 6%;
    width: 4.07vw;
    height: 4.07vw;
}
.list-wallet-position {
    position: absolute;
    top: 27.59259vw; 
    left: 0vw;    
    width: 100vw;
    height: 50vw;
}
.img-icon-url {
    top: 12%; 
    left: 6%;
    height: 9.81vw;
    width: 9.81vw;
}
.wallet-item-bg {
    width: 67.59259vw;
    height: 128.333vw;
}
.list-item-bg {
    position: relative;
    top: 0vw; 
    left: 0vw;    
    background-color: aqua;
}
.wallet-list-item {
    position: relative;
    top: 0vw; 
    left: 0vw;  
    width: 67.59259vw;
    height: 140vw;    
    background-color: rgba(1, 1, 1, 0.0);
}
.list-wallet-bg-02 {
    background-color: rgba(1, 1, 1, 0.0);
}
.wallet-list-item-00 {
    position: absolute;
    top: 0vw; 
    left: 0vw; 
    width: 67.59259vw;
    height: 150vw;
}
.txt-item-position {
    position: absolute;
    top: 0vw; 
    left: 0vw; 
}
.wallet-item-icon {
    position: absolute;
    top: 60vw; 
    left: 50%; 
    width: auto;
    height: 9.8vw;
    -ms-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%); 
}
.wallet-name-position {
    position: absolute;
    top: 73vw; 
    left: 50%; 
    -ms-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%);  
    opacity: 0.9;
    font-family: NanumBarunGothicOTF;
    font-size: 4.4vw;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #191919;   
}
.img-item-price-bg {
    position: absolute;
    top: 80vw; 
    left: 50%; 
    -ms-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%);  
    width: 57.03704vw;
    height: 6.851852vw; 
}
.txt-item-price-value {
    position: absolute;
    top: 80.6vw; 
    left: 50%; 
    -ms-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%);  
    opacity: 0.9;
    font-family: NanumBarunGothicOTF;
    font-size: 3.962963vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #191919;  
}
.wallet-create-new {
    position: absolute;
    top: 80.6vw; 
    left: 50%; 
    -ms-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%);  
    opacity: 0.9;
    font-family: NanumBarunGothicOTF;
    font-size: 3.962963vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #000000;  
}
.img-wallet-top-bg{ 
    position: absolute;
    top: 2vw; 
    left: 2.5vw; 
    height: 50vw;
    width: 62.5vw;  
}
.img-wallet-btn-bg {
    position: absolute;
    top: 93vw; 
    left: 50%; 
    -ms-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%);   
    width: 56.6666vw;
    height: 15.37037vw;        
}
.img-wallet-btn-receive {
    position: absolute;
    top: 96vw; 
    left: 17vw; 
    width: auto;
    height: 5.7vw;      
}
.img-wallet-btn-receive-02 {
    position: absolute;
    top: 96vw; 
    left: 12vw; 
    width: auto;
    height: 5.7vw;      
}
.img-wallet-btn-send {
    position: absolute;
    top: 96vw; 
    left: 48vw; 
    width: auto;
    height: 5.7vw;         
}
.img-wallet-btn-send-02 {
    position: absolute;
    top: 96vw; 
    left: 31.5vw; 
    width: auto;
    height: 5.7vw;         
}
.img-wallet-btn-convert-02 {
    position: absolute;
    top: 96vw; 
    left: 50vw; 
    width: auto;
    height: 5.7vw;         
}
.txt-receive-wallet {
    position: absolute;
    top: 103vw; 
    left: 9.7vw;
    width: 20vw;
    opacity: 0.65;
    font-family: NanumBarunGothicOTF;
    font-size: 2.518519vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #010101;     
}
.txt-receive-wallet-02 {
    position: absolute;
    top: 103vw; 
    left: 4.7vw;
    width: 20vw;
    opacity: 0.65;
    font-family: NanumBarunGothicOTF;
    font-size: 2.518519vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #010101;     
}
.txt-send-wallet {
    position: absolute;
    top: 103vw; 
    left: 41vw; 
    opacity: 0.65;
    width: 20vw;    
    font-family: NanumBarunGothicOTF;
    font-size: 2.518519vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #010101;     
}
.txt-send-wallet-02 {
    position: absolute;
    top: 103vw; 
    left: 24vw; 
    opacity: 0.65;
    width: 20vw;    
    font-family: NanumBarunGothicOTF;
    font-size: 2.518519vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #010101;     
}
.txt-convert-wallet-02 {
    position: absolute;
    top: 103vw; 
    left: 43vw; 
    opacity: 0.65;
    width: 20vw;    
    font-family: NanumBarunGothicOTF;
    font-size: 2.518519vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #010101;     
}
.img-wallet-link-detail {
    position: absolute;
    top: 114vw; 
    width: auto;
    height: 17.87037vw;    
    left: 50%; 
    -ms-transform: translate(-50%, 0%);
    transform: translate(-50%, 0%);         
}
.loading-bar-postion {
    position: absolute;
    top: 50vh;
    left: 50vw; 
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%); 
}
.notice-position {
    position: absolute;
    top: 1.3vw;
    left: 12vw; 
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: white;
}
.option-top-bg {
    position: absolute;
    top: 0vw;
    left: 0vw; 
    width: 100vw;
    height: 100vh; 
    background-color: white;
}
.option-top-line1 {
    position: absolute;
    top: 12.96vw; 
    left: 0vw;    
    width: 100vw;
    height: 1px;
    background-color: lightgray;      
}
.option-top-line2 {
    position: absolute;
    top: 28vw; 
    left: 0vw;    
    width: 100vw;
    height: 1px;
    background-color: lightgray;      
}
.img-logout {
    position: absolute;
    top: 2.9vw; 
    left: 5.5vw;       
    width: auto;
    height: 6.4vw; 
    pointer-events: none;    
}
.option-top-logout {
    position: absolute;
    top: 0vw; 
    left: 0vw;
    width: 30vw;
    height: 13vw; 
}
.option-logout-postion {
    position: absolute;
    top: 4.7vw; 
    left: 14vw;
    font-family: NanumBarunGothicOTF;
    font-size: 3.24vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #646464;     
    pointer-events: none; 
}
.img-option-close {
    position: absolute;
    top: 3.5vw; 
    right: 5vw;    
    width: 5.37vw;
    height: 5.37vw; 
}
.option-close-position {
    position: absolute;
    top: 0vw; 
    right: 0vw;
    width: 30vw;
    height: 13vw; 
}
.option-google-icon-position {
    position: absolute;
    top: 17.5vw; 
    left: 5.3vw;
}
.img-google-icon { 
    height: 4.8vw;
    width: 4.8vw;  
}
.option-email-postion {
    position: absolute;
    top: 17.5vw; 
    left: 12.3vw;
    opacity: 0.9;
    font-family: NanumBarunGothicOTF;
    font-size: 3.68vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #221815;    
}
.option-surpport-bg {
    position: absolute;
    top: 28.33vw; 
    left: 0vw;
}
.img-support-bg {
    height: auto;
    width: 100vw;  
}
.option-notice-postion {
    position: absolute;
    top: 43.14vw; 
    left: 0vw;
    height: 11.11vw;
    width: 100vw;      
}
.option-img-notice-bg {
    height: 11.11vw;
    width: 100vw; 
}
.option-img-notice-bg2 {
    height: 13.88vw;
    width: 100vw; 
}
.option-notice-news {
    position: absolute;
    top: 54.25vw; 
    left: 0vw;
    height: 11.11vw;
    width: 100vw;      
}
.option-notice-push {
    position: absolute;
    top: 65.55vw; 
    left: 0vw;
    height: 11.11vw;
    width: 100vw;      
}
.option-notice-faq {
    position: absolute;
    top: 76.66vw; 
    left: 0vw;
    height: 11.11vw;
    width: 100vw;      
}
.option-notice-pwd {
    position: absolute;
    top: 87vw; 
    left: 0vw;
    height: 11.11vw;
    width: 100vw;     
}
.option-setting-bg {
    position: absolute;
    top: 101vw; 
    left: 0vw;
}
.img-setting-bg {
    height: auto;
    width: 100vw; 
}
.option-txt-center {
    position: absolute;
    top: 50%; 
    left: 12%;
    opacity: 0.9;
    font-family: NanumBarunGothicOTF;
    font-size: 3.68vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    -ms-transform: translate(0%, -50%);
    transform: translate(0%, -50%); 
}
.option-txt-center2 {
    position: absolute;
    top: 20%; 
    left: 12%;
    opacity: 0.9;
    font-family: NanumBarunGothicOTF;
    font-size: 3.68vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
}
.option-txt-center3 {
    position: absolute;
    top: 49%; 
    left: 12%;
    opacity: 0.5;
    font-family: NanumBarunGothicOTF;
    font-size: 2.3vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
}
.option-chage-pwd {
    position: absolute;
    top: 115vw; 
    left: 0vw; 
    height: 13.88vw;
    width: 100vw;  
}
.option-lock-screen {
    position: absolute;
    top: 129vw; 
    left: 0vw;  
}
.option-setting-push {
    position: absolute;
    top: 143vw; 
    left: 0vw;  
}
.option-setting-phone {
    position: absolute;
    top: 157vw; 
    left: 0vw;  
}
.option-txt-logout {
    position: absolute;
    top: 4.5vw; 
    left: 13vw;  
    font-family: NanumBarunGothicOTF;
    font-size: 3.2vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #646464;   
    pointer-events: none;  
}
.select-lang {
    position: absolute;
    top: 0vw; 
    right: 0vw;  
    height: 15vw;
    width: 20vw;     
}
.img-language {
    position: absolute;
    top: 5vw; 
    left: 5vw;      
    height: 4.44vw;
    width: auto; 
}
.lang_dialog_bg {
    position: absolute;
    top: 35vh; 
    left: 10vw;  
    height: 50vw;
    width: 80vw; 
    background-color: white;     
    border-radius: 20px 20px / 20px 20px;
}
.lang_dialog_title {
    position: absolute;
    top: 5vw; 
    left: 0vw;  
    width: 100%;
    font-family: NanumBarunGothicOTF;
    font-size: 3.4vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #191919;    
}
.lang-popup-flag {
    position: absolute;
    top: 3vw; 
    left: 0vw;    
    height: auto;
    width: 8vw; 
}
.lang_dialog_ko {
    position: absolute;
    top: 31vw; 
    left: 10vw; 
    width: 60vw;
    height: 15vw;
}
.lang_dialog_en {
    position: absolute;
    top: 15vw; 
    left: 10vw;
    width: 60vw;
    height: 15vw;         
}
.lang-popup-text {
    position: absolute;
    top: 3vw; 
    left: 11vw;
    font-family: NanumBarunGothicOTF;
    font-size: 3.5vw;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.2;
    letter-spacing: normal;
    text-align: center;
    color: #191919;    
}
.lang-popup-bg {
    position: absolute;
    top: 0vw; 
    left: 0vw;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
}
.background-postion {
    position: absolute;
    top: 0vw; 
    left: 0vw;
    width: 100vw;
    height: 100vh;
}
.img-background-postion {
    position: absolute;
    top: 0vw; 
    left: 0vw;    
    width: 100vw;
    height: 100vh;
    background-color: white;
}
</style>